/*
  Shoesalder: require an explicit size choice.
  Dawn preselects the first variant. When a shopper lands WITHOUT ?variant= (a
  variant URL must keep the advertised size), the size radios are cleared and
  Add to cart stays disabled until a size is picked. Re-applied after Dawn
  re-renders the form (e.g. after a colour change) until a size is chosen.
*/
(function () {
  var hasVariantParam = new URLSearchParams(window.location.search).has('variant');

  function sizeFieldset(root) {
    var sets = root.querySelectorAll('variant-selects fieldset.product-form__input');
    for (var i = 0; i < sets.length; i++) {
      var legend = sets[i].querySelector('legend');
      if (legend && /size/i.test(legend.textContent) && sets[i].querySelectorAll('input[type="radio"]').length > 1) return sets[i];
    }
    return null;
  }

  function enforceButtons(info) {
    info.querySelectorAll('button[name="add"]').forEach(function (btn) {
      if (!btn.disabled) btn.disabled = true;
      var span = btn.querySelector('span') || btn;
      if (span.textContent.trim() !== 'Select a size') span.textContent = 'Select a size';
      var ref = 'sa-size-hint-' + info.id;
      if (btn.getAttribute('aria-describedby') !== ref) btn.setAttribute('aria-describedby', ref);
    });
  }

  function needsEnforce(info) {
    var fs = sizeFieldset(info);
    if (fs && fs.querySelector('input[type="radio"]:checked')) return true;
    return Array.prototype.some.call(info.querySelectorAll('button[name="add"]'), function (b) {
      var span = b.querySelector('span') || b;
      return !b.disabled || span.textContent.trim() !== 'Select a size';
    });
  }

  function apply(info) {
    if (hasVariantParam) info.dataset.saSizeChosen = 'true';
    if (info.dataset.saSizeChosen === 'true') return;
    var fs = sizeFieldset(info);
    if (!fs) return;
    fs.querySelectorAll('input[type="radio"]:checked').forEach(function (r) { r.checked = false; });
    info.classList.add('sa-needs-size');
    enforceButtons(info);
    // sticky add-to-cart dropdowns: show a neutral placeholder instead of a preselected size
    info.querySelectorAll('select[name^="options["]').forEach(function (sel) {
      if (!/size/i.test(sel.name) || sel.querySelector('option[data-sa-placeholder]')) return;
      var ph = document.createElement('option');
      ph.value = ''; ph.disabled = true; ph.textContent = 'Select size';
      ph.setAttribute('data-sa-placeholder', '');
      sel.insertBefore(ph, sel.firstChild);
      sel.selectedIndex = 0;
    });
    if (!info.querySelector('.sa-size-hint')) {
      var hint = document.createElement('p');
      hint.className = 'sa-size-hint';
      hint.id = 'sa-size-hint-' + info.id;
      hint.textContent = 'Please choose your size to continue.';
      fs.appendChild(hint);
    }
  }

  // place the size guide directly beneath the size buttons (stays above the options without JS)
  function placeGuide(info) {
    var guide = info._saGuide || info.querySelector('.sa-sg');
    if (!guide) return;
    info._saGuide = guide; // keep the node: Dawn re-renders the option pickers on every change
    var fs = sizeFieldset(info);
    if (!fs) return;
    // premium product page: the link sits in the size label row (right-aligned by CSS)
    if (info.classList.contains('sa-premium')) {
      var legend = fs.querySelector('legend');
      if (!legend || legend.nextElementSibling === guide) return;
      guide.classList.add('sa-sg--legend');
      legend.insertAdjacentElement('afterend', guide);
      return;
    }
    if (fs.nextElementSibling === guide) return;
    guide.classList.add('sa-sg--inline');
    fs.insertAdjacentElement('afterend', guide);
  }

  // size guide dialog: opening keeps the chosen variant and scroll position; focus returns to the trigger
  document.addEventListener('click', function (e) {
    var open = e.target.closest('.sa-sg__open');
    if (open) {
      var dlg = document.getElementById(open.getAttribute('aria-controls'));
      if (dlg && typeof dlg.showModal === 'function') {
        e.preventDefault();
        dlg._saTrigger = open;
        dlg.showModal();
        document.documentElement.classList.add('sa-dialog-open');
      }
      return;
    }
    var dialog = e.target.closest('.sa-sg__dialog');
    if (dialog && (e.target.closest('[data-sa-close]') || e.target === dialog)) dialog.close();
  });
  document.addEventListener('close', function (e) {
    if (!e.target.classList || !e.target.classList.contains('sa-sg__dialog')) return;
    document.documentElement.classList.remove('sa-dialog-open');
    if (e.target._saTrigger) e.target._saTrigger.focus({ preventScroll: true });
  }, true);

  function init(info) {
    if (info.dataset.saInit) return;
    info.dataset.saInit = 'true';
    placeGuide(info);
    apply(info);
    info.addEventListener('change', function (e) {
      var fs = e.target.closest('fieldset');
      var legend = fs && fs.querySelector('legend');
      var isSizeSelect = e.target.tagName === 'SELECT' && /size/i.test(e.target.name || '');
      if ((legend && /size/i.test(legend.textContent)) || isSizeSelect) {
        info.dataset.saSizeChosen = 'true';
        info.classList.remove('sa-needs-size');
        var hint = info.querySelector('.sa-size-hint');
        if (hint) hint.remove();
      }
    });
    new MutationObserver(function () {
      placeGuide(info);
      if (info.dataset.saSizeChosen === 'true') return;
      if (needsEnforce(info)) apply(info);
    }).observe(info, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
  }

  // wide supplier size tables scroll sideways: make them reachable by keyboard
  function tables() {
    document.querySelectorAll('.product__description table:not([tabindex])').forEach(function (t) {
      t.setAttribute('tabindex', '0');
      t.setAttribute('role', 'region');
      t.setAttribute('aria-label', 'Size chart, scrolls horizontally');
    });
  }

  function scan() {
    tables(); document.querySelectorAll('product-info').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  // quick-add modals and theme-editor reloads insert new product-info elements
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', scan);
})();

/*
  Shoesalder mobile purchase bar (snippets/sa-buy-bar.liquid). It has no variant state of
  its own: it mirrors the main Add to cart button and forwards clicks to it, so it can never
  add a different variant. While a size is still needed it scrolls to the size buttons.
*/
(function () {
  var mq = window.matchMedia('(max-width: 749px)');

  function setup(bar) {
    if (bar.dataset.saReady) return;
    var info = document.querySelector('product-info[data-section="' + bar.dataset.saBuybar + '"]') ||
      document.getElementById('MainProduct-' + bar.dataset.saBuybar);
    if (!info) return;
    bar.dataset.saReady = 'true';
    var btn = bar.querySelector('[data-sa-buybar-btn]');
    var priceEl = bar.querySelector('[data-sa-buybar-price]');
    var variantEl = bar.querySelector('[data-sa-buybar-variant]');
    var mainVisible = true;
    function setText(el, t) { if (el.textContent !== t) el.textContent = t; }

    function mainBtn() { return info.querySelector('.product-form__buttons button[name="add"]') || info.querySelector('button[name="add"]'); }
    function sizeSet() {
      var sets = info.querySelectorAll('variant-selects fieldset');
      for (var i = 0; i < sets.length; i++) {
        var l = sets[i].querySelector('legend');
        if (l && /size/i.test(l.textContent)) return sets[i];
      }
      return null;
    }
    function needsSize() { return info.classList.contains('sa-needs-size'); }

    function sync() {
      var main = mainBtn();
      if (!main) return;
      var label = ((main.querySelector('span') || main).textContent || '').trim();
      var needs = needsSize();
      setText(btn, needs ? 'Select a size' : label);
      // sold out / unavailable stays disabled; "needs a size" stays clickable so it can guide the shopper
      var dis = !needs && main.disabled;
      if (btn.disabled !== dis) btn.disabled = dis;
      var wrap = info.querySelector('[id^="price-"] .price');
      if (wrap) {
        var p = wrap.classList.contains('price--on-sale') ? wrap.querySelector('.price__sale .price-item--last') : wrap.querySelector('.price__regular .price-item--regular');
        if (p && p.textContent.trim()) setText(priceEl, p.textContent.trim());
      }
      var picked = [];
      info.querySelectorAll('variant-selects fieldset').forEach(function (fs) {
        var c = fs.querySelector('input[type="radio"]:checked');
        if (c) picked.push(c.value);
      });
      setText(variantEl, needs ? (picked.length ? picked.join(' / ') + ' · choose a size' : 'Choose a size') : picked.join(' / '));
    }

    function show() {
      var on = mq.matches && !mainVisible;
      bar.hidden = !on;
      document.documentElement.classList.toggle('sa-buybar-on', on);
    }

    btn.addEventListener('click', function () {
      var main = mainBtn();
      if (needsSize()) {
        var fs = sizeSet();
        if (fs) {
          fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var first = fs.querySelector('input[type="radio"]:not(:disabled)') || fs.querySelector('input[type="radio"]');
          if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 400);
        }
        return;
      }
      if (main && !main.disabled) main.click();
    });

    var target = mainBtn();
    if (target && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        mainVisible = entries[0].isIntersecting;
        show();
      }).observe(target.closest('.product-form__buttons') || target);
    }
    if (mq.addEventListener) mq.addEventListener('change', show);
    // Dawn re-renders price and buttons on every variant change
    new MutationObserver(function (records) {
      if (records.every(function (r) { return bar.contains(r.target); })) return;
      sync();
    }).observe(info, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class'] });
    info.addEventListener('change', function () { setTimeout(sync, 50); });
    sync();
    show();
  }

  function scan() { document.querySelectorAll('[data-sa-buybar]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
